import { render, staticRenderFns } from "./carinfo.vue?vue&type=template&id=381e24c3"
import script from "./carinfo.vue?vue&type=script&lang=js"
export * from "./carinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports